export enum ModalSize {
  SMALL = 'SMALL',
  LARGE = 'LARGE',
  FIT = 'FIT',
}

export interface StateProps {
  modalType: any
  multiple: boolean
}

export interface OwnProps {
  t: any
  children: any
  handleClose: () => void
  handlePrevious: () => void
  size?: ModalSize
  type: any
  previewDocument: boolean
  downloadFile: () => void
  invoiceData: IInvoice
  onDownload: () => void
  onRefreshInvoice: (id: string) => void
  onPrint: () => void
  isInvoice: boolean
  disable: boolean
  details: any
}

export interface IInvoice {
  account_id: number
  created_at: string
  date: IInvoiceTitle
  id: string
  name: IInvoiceTitle
  price: IInvoiceTitle
  source_id: number
  type: number
  updated_at: string
}

export interface IInvoiceTitle {
  title: string
}

export interface DispatchProps {
  setHideModal: (isMultiple: boolean) => void
}

export type Props = StateProps & OwnProps & DispatchProps
